import { render, staticRenderFns } from "./SystemUsageCard.vue?vue&type=template&id=3fa4da39&"
import script from "./SystemUsageCard.vue?vue&type=script&lang=ts&"
export * from "./SystemUsageCard.vue?vue&type=script&lang=ts&"
import style0 from "./SystemUsageCard.vue?vue&type=style&index=0&id=3fa4da39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports